export const hideSidebar = {
  beforeMount() {
    this.$store.commit('sidebar/SET_SHOW_SIDEBAR', false);
    this.$store.commit('popups/errorLogin/SET_RECOVERY_SUCCESS', false);
    this.$store.commit('popups/SHOW_OVERLAY', false);
  },
  // destroyed() {
  //   this.$store.commit('sidebar/SET_SHOW_SIDEBAR', true)
  // }
}
